import React from 'react'
import { Document, Page, Text, View, StyleSheet, Font, Image,  } from '@react-pdf/renderer';
import { HoraActual, calcularEdad, fechaActual } from '../../../hooks/UseDate';
import logo from '../../../images/Logo-G-Ocho.png';

// Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const styles = StyleSheet.create({
  page: {
    padding: 10,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    width: '50%',      
    fontSize: 10
  },
  bold:{
    fontFamily: 'Open Sans',
    fontWeight: 600
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "none",      
  }, 
  tableRow: {       
    flexDirection: "row" 
  },   
  tableCell: { 
    width: "10%",
    padding: '3px',      
    fontSize: 8 
  },  
  tableCellLarge:{
    width: "50%",
    padding: '3px',      
    fontSize: 8 
  }, 
  columnMedico:{
    width: '33.33%',      
    fontSize: 8
  },
  containerRecibeEntrega: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    //marginBottom: 10, // O cualquier valor que desees para el margen inferior
  },
  textIzquierda: {
    textAlign: 'left',
    // otros estilos para el texto izquierdo
  },
  textDerecha: {
    textAlign: 'right',
    // otros estilos para el texto derecho
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 60, 
    height: 60, 
    margin: '10px',
  },
});

const PDFImprimirDespachosQxFarmacia = ({dataImprimir,dataSuministrosImprimir,estadoDespacho,dataQuienRecibe,dataQuienEntrega}) => {
  
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.image} src={logo} />
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataImprimir.EmpRazSoc? dataImprimir.EmpRazSoc:null}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{dataImprimir.EmpNit? dataImprimir.EmpNit:null}</Text>
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DESPACHOS DE FARMACIA</Text>
        <Text style={{ fontSize: 7,}}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}</Text>
        <Text style={{ fontSize: 7,}}><Text style={styles.bold}>Hora:</Text> {HoraActual()}</Text>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>

        <View style={styles.container}>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Paciente:</Text>  {dataImprimir.MPNOMC? dataImprimir.MPNOMC.trim():null}</Text>
            <Text><Text style={styles.bold}>Edad:</Text> {dataImprimir.MPFchN? calcularEdad(dataImprimir.MPFchN.split(" ")[0]):null} Años</Text>
            <Text><Text style={styles.bold}>Empresa:</Text> {dataImprimir.ProNEPS? dataImprimir.ProNEPS:null}</Text>            
          </View>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Identificación:</Text> {dataImprimir.MPCedu? dataImprimir.MPCedu:null}</Text>
            <Text><Text style={styles.bold}>Sexo:</Text> {dataImprimir.MPSexo? dataImprimir.MPSexo:null}</Text>
            <Text><Text style={styles.bold}>Cirugia:</Text> {dataImprimir.ProCirCod?dataImprimir.ProCirCod:null}</Text>
          </View>          
        </View>        
        <Text style={{ fontSize: 10,}}><Text style={styles.bold}>Paquete:</Text> {dataImprimir.PaqCod?dataImprimir.PaqCod.trim():null} -  {dataImprimir.PaqDes?dataImprimir.PaqDes.trim():null}</Text>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
        <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>Código</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>Descripción</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Hora/Fecha Despacho</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Est Dsp</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad ordenada</Text> 
                  </View>
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad despacha.</Text> 
                  </View>
                  {/* <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Documento</Text> 
                  </View> */}
                </View>
                 { 
                     dataSuministrosImprimir.map((item,index)=>( 
                        <>
                        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 2, marginTop:2}}/>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >{item.MSRESO? item.MSRESO.trim():null}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{item.MSNomG?item.MSNomG.trim():null}</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.PQFecHDes?item.PQFecHDes:null}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{estadoDespacho? (estadoDespacho === 'P' || estadoDespacho === 'C'? 'NO':'SI'):null}</Text> 
                            </View>     
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuSl? item.PQCaSuSl:null}</Text> 
                            </View>        
                            <View style={styles.tableCell}> 
                                <Text >{item.PQCaSuDs? item.PQCaSuDs:null}</Text> 
                            </View>                   
                        </View>
                        <View style={styles.container}>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Concentración:</Text> {item.caracteristicasSuministros?item.caracteristicasSuministros[0].CncDes.trim():null}</Text>                          
                          </View>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Forma:</Text> {item.caracteristicasSuministros?item.caracteristicasSuministros[0].FSmDscUMd.trim():null}</Text>
                          </View>
                          <View style={styles.columnMedico}>
                            <Text><Text style={styles.bold}>Marca:</Text> {item.caracteristicasSuministros?item.caracteristicasSuministros[0].MarDsc.trim():null}</Text>                          
                          </View>
                        </View>
                        </>
                     )) 
                 } 
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        <View style={styles.containerRecibeEntrega}>
          <View style={styles.textIzquierda}>
          <Text style={{ fontSize: 10,}}>{dataQuienEntrega? dataQuienEntrega.PQUsrMov:null}</Text>
            <Text style={{ fontSize: 10,}}>Quien Entrega</Text>
          </View>
          <View style={styles.textDerecha}>
            <Text style={{ fontSize: 10,}}>{dataQuienRecibe.MMNomM?dataQuienRecibe.MMNomM.trim():null}</Text>
            <Text style={{ fontSize: 10,}}>Quien Recibe</Text>            
          </View>
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}> * * *   FIN DEL REPORTE   * * *</Text>
      </Page>     
    </Document>
  )
}

export default PDFImprimirDespachosQxFarmacia